import {
    ResponsiveContainer,
    ComposedChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    CartesianGrid,
    Label
} from 'recharts';
import { Box, Grid, Typography } from '@mui/material';
import { filterBarKeysIfNoData, formatGraphAxis, BarGraphTooltip, CustomLegend, formatTicker } from '../utils/graph-utils';
import { barSize, legendHeight, legendIconSize, stackedBarCategoryGap, stackedContainerWidth, stackedGraphFontSize, responsiveContainerHeight, facilityColors, composedChartMarginForStackedGraph, maxGraphBoxWidth, chartOffset } from '../constants/graph-constants';
import NoGraphData from './NoGraphData';

export default function FacilityStackedBarGraph({ stackedBarGraphData, groupName, facilities, year, type, unit }) {
    return (
        <NoGraphData data={stackedBarGraphData} year={year} type={type} variant={'stacked-bar-graph'}>
            <Grid xs={12} item display="flex" justifyContent={'center'} mb={'3rem'}>
                <StackedBarGraphForFacilities data={stackedBarGraphData} facilities={facilities} group={groupName} type={type} year={year} unit={unit} />
            </Grid>
        </NoGraphData>
    );
}

function StackedBarGraphForFacilities({ data, year, type, group, facilities, unit }) {

    const filteredBarKeys = filterBarKeysIfNoData(facilities, data);
    const sortedAndFilteredBarKeys = filteredBarKeys?.slice().sort((a, b) => a.localeCompare(b))

    return (
        <Box sx={{ width: '100%', height: '100%', maxWidth: maxGraphBoxWidth }}>
            <Typography variant="h6" align="center" gutterBottom>
                {group} {type} {year}
            </Typography>
            <ResponsiveContainer width={stackedContainerWidth} height={responsiveContainerHeight} style={{ justifySelf: 'center' }}>
                <ComposedChart data={data} margin={composedChartMarginForStackedGraph} barSize={barSize} barCategoryGap={stackedBarCategoryGap}>
                    <CartesianGrid stroke="#f5f5f5" />
                    <XAxis
                        dataKey="category"
                        tickFormatter={label => label.length > 13 && type === 'Purchased Capital Goods and Services' ? label.slice(0, 13) + '…' : label}
                        fontSize={stackedGraphFontSize}
                    />
                    <YAxis
                        fontSize={stackedGraphFontSize}
                        domain={([dataMin, dataMax]) => { const yAxisDisplayMax = formatGraphAxis(dataMax, dataMin); return yAxisDisplayMax }}
                        tickFormatter={value => formatTicker(value)}
                    >
                        <Label angle={-90} value={unit} position={'insideLeft'} offset={chartOffset} fontSize={stackedGraphFontSize} />
                    </YAxis>
                    <Tooltip content={<BarGraphTooltip reversed={true} />} />
                    <Legend content={<CustomLegend variant={'facility'} />} iconSize={legendIconSize} verticalAlign='top' height={legendHeight} />
                    {sortedAndFilteredBarKeys?.map(barKey => (
                        <Bar
                            key={barKey}
                            stackId={1}
                            dataKey={barKey}
                            fill={facilityColors[barKey] || '#ccc'}
                            name={barKey}
                        />
                    ))}
                </ComposedChart>
            </ResponsiveContainer>
        </Box>
    )
}